import * as React from 'react';

import './BrainsView.scss'

import _ from 'lodash'
import { NavBar } from '../../Models/NavBar/NavBar.Model';
import { useMatch } from 'react-router-dom';

import { BrainsModel } from '../../Models/Brains/Brains.Model';
import { PageLoadingView } from '../../App/Layout/Loading/LoadingView';
import NLPBrainsView from './NLPBrainView';
import LLMBrainView from './LLMBrainView';
import { InheritanceStatus, BrainType, NLPBrainInterface, LLMBrainInterface } from '@swivl-mono/types';

export default function BrainsView() {
  const match = useMatch("/brain/:brainSlug");
  const { brains, brainsMap } = BrainsModel.useState(state => state);
  const brain = match && match.params && match.params.brainSlug && brainsMap ? brainsMap[match.params.brainSlug] : null;


  // const brain = React.useMemo(() => {
  //   if (!brainsMap) return null;
  //   return brainsMap[match.params.brainSlug];
  // }, [match.params, brainsMap]);





  React.useEffect(() => {
    BrainsModel.load(false)
  }, [])

  React.useEffect(() => {
    if (!brain) return;
    NavBar.set(
      <NavBar.Component.Back />,
      brain.inheritance !== InheritanceStatus.IS_PARENT ? <NavBar.Component.Title title={brain.name} canEdit={true} onSave={async (name) => {
        let _brain = { ...brain }
        _brain.name = name
        await BrainsModel.updateBrain(_brain, true)
      }} /> : <NavBar.Component.Title title={brain.name} />,
      null,
      brain.name
    );
  }, [brain])



  if (!brain) return <PageLoadingView />;
  if (brain.type === BrainType.NLP || brain.type === BrainType.CLU) {
    return <NLPBrainsView brain={brain as NLPBrainInterface} />
  }
  if (brain.type === BrainType.LLM) {
    return <LLMBrainView brain={brain as LLMBrainInterface} />
  }


  return <div className="BrainsView">
    Unknown Brain Type
  </div>
}




